export const getAvatarInitials = (fullName = '') => {
  const names = fullName.split(' ')
  return `${names[0]?.[0]}${names[names.length - 1]?.[0]}`
}
